import { useEffect, useState } from 'react';

import { applyTheme, readTheme, type Theme } from 'src/lib/theme';

/**
 * Dark is a real mode, not an inversion, and it stays warm (Art Direction §15).
 *
 * The toggle changes the theme; it does not own it. `installTheme` applied it before this mounted,
 * which is what lets the reader — a screen with no toggle at all — still honour the choice.
 */
export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(readTheme);

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={() => setTheme(current => (current === 'dark' ? 'light' : 'dark'))}
      aria-label={theme === 'dark' ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'}
    >
      {/* Both icons stay mounted, stacked in the same grid cell — the one for the theme a click
          would switch to cross-fades in while the other blurs and shrinks out (transitions.dev
          §09 icon swap). Icon shown is the destination, same as before this was animated. */}
      <span className="t-icon-swap" data-state={theme}>
        <span className="t-icon" data-icon="dark" aria-hidden="true">☀</span>
        <span className="t-icon" data-icon="light" aria-hidden="true">☾</span>
      </span>
    </button>
  );
}
